import request from "@/axios";

/** 获取业务字典中的展示页面 */
export const getShowPages = () => {
  return request({
    url: "/lebo-system/dict-biz/dictionary",
    method: "get",
    params: {
      code: "app_card_show_strategy"
    }
  });
}

/** 获取app卡片列表的数据 */
export const getAppCardList = (params) => {
  return request({
    url: "/lebo-card/addCard/page",
    method: "get",
    params
  });
}

/** 新增页面策略的接口 */
export const addPageStrategy = (data) => {
  return request({
    url: "/lebo-card/appCardStrategy/local/save",
    method: "post",
    data
  });
}

/** 编辑页面策略的接口 */
export const editPageStrategy = (data) => {
  return request({
    url: "/lebo-card/appCardStrategy/local/update",
    method: "post",
    data
  });
}

/** 获取协议版本选项 */
export const getProtocolVersionOptions = () => {
  return request({
    url: '/lebo-system/dict-biz/dictionary',
    method: 'get',
    params: {
      code: 'APP_PROTOCOL_VERSION'
    }
  });
};

/** 获取生效投屏功能配置 */
export const getScreenConfig = () => {
  return request({
    url: "/lebo-card/appScreenCastConfig/list",
    method: "get",
  });
};